import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DsTextComponent } from '@design-system/ds-text/component/ds-text.component';

/**
 * Shows the numbered title of one section of the block time record modal.
 * The number is decorative, so screen readers read only the heading text.
 */
@Component({
  selector: 'app-btr-section-title',
  templateUrl: './btr-section-title.component.html',
  styleUrls: ['./btr-section-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DsTextComponent],
})
export class BtrSectionTitleComponent {
  @Input() step = 1;
  @Input() text = '';
  /** The id of the heading, for the aria-labelledby of the section. */
  @Input() headingId = '';

  readonly titleColor = 'var(--tac-primary-title-color)';
}
